import { useEffect } from "react";
import { Pencil, Trash2, Image as ImageIcon, Video } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { ApiMediaURL } from "../../../../setting/GlobleVariable";
import {
  DeleteCraousalEvent,
  GetAllCraousalEvent,
} from "../../../../redux/actions/Admin/AdminActions";
const Carousal = ({ EditCarousal }) => {
  const carousalData = useSelector((state) => state.Admin.carousalData);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetAllCraousalEvent());
  }, [dispatch]);

  const list = Array.isArray(carousalData) ? carousalData : [];

  return (
    <div className="space-y-3">
      {list.length > 0 ? (
        list.map((item, index) => {
          const eventName = item?.event?.[0]?.name || "Unnamed event";
          const paragraph = item?.paragraph || "";
          const isVideo = item?.mediaType === "video";
          const mediaSrc = isVideo
            ? item?.video
              ? `${ApiMediaURL}/${item.video}`
              : null
            : item?.image
              ? `${ApiMediaURL}/${item.image}`
              : null;

          return (
            <div
              key={item?._id || index}
              className="bg-[#0F172A] border border-[#1a2744] rounded-xl overflow-hidden flex flex-col sm:flex-row"
            >
              <div className="w-full sm:w-[220px] h-28 sm:h-32 bg-[#1a2744] shrink-0 relative overflow-hidden">
                {mediaSrc ? (
                  isVideo ? (
                    <video
                      src={mediaSrc}
                      className="w-full h-full object-cover"
                      muted
                      playsInline
                    />
                  ) : (
                    <img src={mediaSrc} alt="" className="w-full h-full object-cover" />
                  )
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <span className="text-[10px] text-white/15">No media</span>
                  </div>
                )}
                {item?.isOverLay && (
                  <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-black/50 text-[9px] text-white/70 uppercase tracking-wider" style={{ fontWeight: 600 }}>
                    Overlay
                  </div>
                )}
              </div>

              <div className="flex-1 p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 min-w-0">
                <div className="min-w-0 flex-1">
                  <div className="text-[14px] text-white mb-1 truncate" style={{ fontWeight: 700 }}>
                    {eventName}
                  </div>
                  <p className="text-[11px] text-white/30 mb-2 line-clamp-2">
                    {paragraph || "—"}
                  </p>
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[9px] uppercase tracking-wider ${
                        isVideo
                          ? "bg-violet-500/15 text-violet-400"
                          : "bg-blue-500/15 text-blue-400"
                      }`}
                      style={{ fontWeight: 600 }}
                    >
                      {isVideo ? (
                        <Video className="w-3 h-3" />
                      ) : (
                        <ImageIcon className="w-3 h-3" />
                      )}
                      {isVideo ? "Video" : "Image"}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-2 shrink-0">
                  <button
                    type="button"
                    onClick={() => EditCarousal(item)}
                    className="w-9 h-9 rounded-lg flex items-center justify-center bg-blue-500/10 text-blue-400 hover:bg-blue-500/20 transition-all"
                    title="Edit"
                  >
                    <Pencil className="w-4 h-4" />
                  </button>
                  <button
                    type="button"
                    onClick={() => dispatch(DeleteCraousalEvent(item._id))}
                    className="w-9 h-9 rounded-lg flex items-center justify-center bg-red-500/10 text-red-400 hover:bg-red-500/20 transition-all"
                    title="Delete"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="bg-[#0F172A] border border-[#1a2744] rounded-xl py-16 px-6 text-center text-white/30 text-[13px]">
          No carousel banners yet. Click &quot;Add Banner&quot; to create one.
        </div>
      )}
    </div>
  );
};

export default Carousal;
